import { render, staticRenderFns } from "./DocBox.vue?vue&type=template&id=caf5222a&scoped=true&"
import script from "./DocBox.vue?vue&type=script&lang=js&"
export * from "./DocBox.vue?vue&type=script&lang=js&"
import style0 from "./DocBox.vue?vue&type=style&index=0&id=caf5222a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "caf5222a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('caf5222a')) {
      api.createRecord('caf5222a', component.options)
    } else {
      api.reload('caf5222a', component.options)
    }
    module.hot.accept("./DocBox.vue?vue&type=template&id=caf5222a&scoped=true&", function () {
      api.rerender('caf5222a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2O8L2ShFSGyBz/JS/comp/DocBox.vue"
export default component.exports